import React from 'react';
import styled, { css } from 'styled-components';
import useSocialmedia from 'gatsby-theme-core/src/hooks/use-socialmedia';

import {
  Twitter,
  Facebook,
  Youtube,
  Linkedin,
  Instagram,
  Snapchat,
  TikTok,
  Headphones,
} from './icons';


const Socials = ({
  variant = 'default',
  className,
}) => {
  const {
    facebook,
    youtube,
    linkedin,
    instagram,
    twitter,
    snapchat,
    tiktok,
    clubhouse,
  } = useSocialmedia();
  return (
    <SocialWrapper
      $variant={variant}
      className={className}
    >
      {twitter && (
        <Social
          href={twitter}
          $variant={variant}
          title="Volg mij op Twitter"
        >
          <Twitter />
        </Social>
      )}
      {facebook && (
        <Social
          href={facebook}
          $variant={variant}
          title="Like ons op Facebook"
        >
          <Facebook />
        </Social>
      )}
      {youtube && (
        <Social
          href={youtube}
          $variant={variant}
          title="Abonneer op mijn youtube kanaal"
        >
          <Youtube />
        </Social>
      )}
      {linkedin && (
        <Social
          href={linkedin}
          $variant={variant}
          title="Link met mij op LinkedIn"
        >
          <Linkedin />
        </Social>
      )}
      {instagram && (
        <Social
          href={instagram}
          $variant={variant}
          title="Volg mij op Instagram"
        >
          <Instagram />
        </Social>
      )}
      {snapchat && (
        <Social
          href={snapchat}
          $variant={variant}
          title="Word vrienden op Snapchat"
        >
          <Snapchat />
        </Social>
      )}
      {tiktok && (
        <Social
          href={tiktok}
          $variant={variant}
          title="Volg mij op tiktok"
        >
          <TikTok />
        </Social>
      )}
      {clubhouse && (
        <Social
          href=" https://apps.apple.com/us/app/clubhouse-drop-in-audio-chat/id1503133294"
          $variant={variant}
          title={`Luister mee met ${clubhouse} op Clubhouse`}
        >
          <Headphones />
        </Social>
      )}
    </SocialWrapper>
  );
};

const SocialWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  ${({ $variant, theme }) => $variant === 'widget' && css`
    display: grid;
    grid-auto-rows: auto;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: ${theme.grid.gap};
    @media all and (min-width: ${theme.breakingpoints.lg}) {
      display: flex;
    }
  `}
`;

export const Social = styled.a.attrs(({ title }) => ({
  'aria-label': title,
}))`
  background-color: ${({ theme }) => theme.primaryColor};
  border-radius: 50%;
  height: 38px;
  width: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;

  ${({ $variant, theme }) => $variant === 'footer' && css`
    background-color: white;
    color: ${theme.backgroundColor};
  `}

  ${({ $variant, theme }) => $variant === 'widget' && css`
    background-color: white;
    color: ${theme.secondaryColor};
    height: 72px;
    width: 72px;
    margin: 0 auto;
    @media all and (min-width: ${theme.breakingpoints.lg}) {
      margin: 0;
      height: 90px;
      width: 90px;
    }
  `}

  svg {
    height: 20px;
    ${({ $variant, theme }) => $variant === 'widget' && css`
      height: 40px;
      @media all and (min-width: ${theme.breakingpoints.lg}) {
        height: 50px;
      }
    `}
  }
  &:hover {
    background-color: ${({ theme }) => theme.fontColor};
    ${({ $variant, theme }) => $variant === 'footer' && css`
      background-color: ${theme.primaryColor};
    `}
  }
`;

export default styled(Socials)``;
